import { UTM_URL, utmApi } from '@services/utm/utm.api';

import { DroneClearance } from '@/types/utm/drone.types';

export const droneClearanceApi = utmApi.injectEndpoints({
  endpoints: (builder) => ({
    changeDroneClearance: builder.mutation<void, DroneClearance>({
      query: (droneClearance) => ({
        url: `${UTM_URL}/drone-clearances`,
        method: 'PUT',
        body: { ...droneClearance },
      }),
    }),
  }),
});

export const { useChangeDroneClearanceMutation } = droneClearanceApi;
